import React from 'react';
import { Card } from 'primereact/card';
import { useSelector } from 'react-redux';
import { useGetEmployeeServiceNowApprovalsQuery, ServiceNowApproval } from '../../features/serviceNowApprovals/serviceNowApprovalsSlice';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import './ServiceNowApprovalsList.scss';

interface ServiceNowApprovalsListProps {
    className?: string;
    setAskNowCount?: React.Dispatch<React.SetStateAction<number>>;
}

const ServiceNowApprovalsList: React.FC<ServiceNowApprovalsListProps> = ({ className, setAskNowCount }) => {
    const currentEmployeeId = useSelector(selectCurrentEmpid);

    const {
        data: approvalsData,
        isLoading,
        error,
    } = useGetEmployeeServiceNowApprovalsQuery(currentEmployeeId?.toString() || '', {
        skip: !currentEmployeeId,
        refetchOnMountOrArgChange: true,
    });

    const approvals = approvalsData?.data?.result || [];

    // Handle card click to open ServiceNow in new tab

    
    const handleCardClick = (sysId: string) => {
        const serviceNowBaseUrl = process.env.REACT_APP_SERVICE_NOW_APPROVER_LIST_URL;
        const serviceNowUrl = `${serviceNowBaseUrl}${sysId}`;
        window.open(serviceNowUrl, '_blank', 'noopener,noreferrer');
    };

    if (isLoading) {
        return (
            <div className={`servicenow-approvals-list ${className || ''}`}>
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                    <p>Loading approvals...</p>
                </div>
            </div>
        );
    }else if (setAskNowCount) {
            setAskNowCount(approvals.length);
        }

    if (error) {
        return (
            <div className={`servicenow-approvals-list ${className || ''}`}>
                <div style={{ padding: '2rem', textAlign: 'center', color: '#6B7280' }}>
                    Unable to load ServiceNow approvals
                </div>
            </div>
        );
    }

    if (approvals.length === 0) {
        return (
            <div className={`servicenow-approvals-list ${className || ''}`}>
                <div style={{ padding: '2rem', textAlign: 'center', color: '#6B7280' }}>
                    No ServiceNow approvals found
                </div>
            </div>
        );
    }

return (
    <div className="servicenow-approvals-wrapper">
        <div className={`servicenow-approvals-list ${className || ''}`}>
            {approvals.map((approval: ServiceNowApproval, index: number) => (
                <Card
                    key={approval['sysapproval.sys_id'] || index}
                    className="approval-card"
                    onClick={() => handleCardClick(approval['sysapproval.sys_id'])}
                    style={{
                        boxSizing: 'border-box',
                        width: '100%',
                        minHeight: '132px',
                        background: '#FFFFFF',
                        border: '1px solid #CECECD',
                        borderRadius: '24px',
                        padding: '1.5rem',
                        marginBottom: '1rem',
                        position: 'relative',
                    }}
                >
                    {/* Header with red circle and ticket number */}
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        marginBottom: '1rem' 
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50%',
                                    backgroundColor: '#E53935',
                                    flexShrink: 0,
                                }}
                            />
                            <span style={{ 
                                fontSize: '1.125rem', 
                                fontWeight: '600', 
                                color: '#3F3F46',
                                letterSpacing: '-0.01em'
                            }}>
                                Ticket No. {approval.sysapproval}
                            </span>
                        </div>
                        <i 
                            className="pi pi-chevron-right" 
                            style={{ 
                                color: '#9CA3AF', 
                                fontSize: '1.25rem' 
                            }} 
                        />
                    </div>

                    {/* Content with requested by and created by */}
                    <div style={{ 
                        display: 'flex', 
                        gap: '3rem',
                        marginBottom: '0.75rem'
                    }}>
                        <div style={{ fontSize: '0.875rem', color: '#52525B' }}>
                            <span >Requested by: </span>
                            <span >
                                {approval['sysapproval.u_requested_for'] || approval['sysapproval.opened_by.name']}
                            </span>
                        </div>
                        <div style={{ fontSize: '0.875rem', color: '#52525B' }}>
                            <span >Created by: </span>
                            <span >
                                {approval['sysapproval.opened_by.name']}
                            </span>
                        </div>
                    </div>

                    {/* Created Date */}
                    <div style={{ fontSize: '0.875rem', color: '#52525B' }}>
                        Created Date: {approval['sysapproval.sys_created_on']}
                    </div>
                </Card>
            ))}
        </div>
        
        <div className="servicenow-bottom-line" />
    </div>
);
};

export default ServiceNowApprovalsList;
